import { inject } from '@angular/core';
import { combineLatest, map, Observable, take } from 'rxjs';
import { IntroductionV2Service } from '@introduction/infra';

export class ShouldShowIntroductionQueryHandler {
  private readonly introductionV2Service: IntroductionV2Service = inject(IntroductionV2Service);

  shouldShow(userId: string): Observable<boolean> {
    return combineLatest([
      this.introductionV2Service.isCompleted(userId),
      this.introductionV2Service.hasLegacyIntroduction(userId)
    ]).pipe(
      take(1),
      map(([isCompleted, hasLegacy]: [boolean, boolean]) => !isCompleted && !hasLegacy)
    );
  }
}
